import { render, staticRenderFns } from "./OrgLicence.vue?vue&type=template&id=bca16090&scoped=true"
import script from "./OrgLicence.vue?vue&type=script&lang=js"
export * from "./OrgLicence.vue?vue&type=script&lang=js"
import style0 from "./OrgLicence.vue?vue&type=style&index=0&id=bca16090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca16090",
  null
  
)

export default component.exports